import { ServerFetch } from '../main-model'

export default class ReceiptCarListModel extends ServerFetch {
    getReceiptCarListBy = (data) => this.authFetch({
        url: 'receipt-car-list/getReceiptCarListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

}